/* eslint-disable */
const terms = "He leído y acepto los {{terms_and_conditions}} de Time Out"
export default {
  'es-419': {
    common: {
      NAME_HOLDER: "Nombre *",
      LAST_NAME_HOLDER: "Apellido *",
      EMAIL_HOLDER: "Correo electrónico *",
      PASS_HOLDER: "Crear contraseña *",
      REPEAT_PASS_HOLDER: "Repetir contraseña *",
      BUTTON_EMAIL_SIGN_UP: "Inicia sesión con tu correo electrónico",

      TERMS_AND_CONDITIONS: "términos y las condiciones",
      PRIVACY_POLICY: "política de privacidad",

      NEWSLETTER_CONSENT: "Acepto recibir comunicaciones relevantes de Time Out, incluidas noticias, eventos, ofertas y promociones de clientes.",
      TERM_OF_USE: terms,
      TERM_OF_USE_WITH_NEWSLETTERS: "Acepto los {{terms_and_conditions}} de Time Out, incluyendo el registro a la newsletter.",

      HEADER_TITLE: "Crear una cuenta de Time Out",
      JOIN_FB: "Únete con Facebook",
      JOIN_TW: "Únete con Twitter",
      JOIN_GG: "Únete con Google",
      JOIN_EM: "Únete con tu correo electrónico",
      ALREADY_HAVE: "¿Ya tienes una cuenta en Time Out?",
      CREATE_ACCOUNT_LOG_IN: "Conéctate",

      SIGN_IN_TITLE: "Inicia sesión",
      SIGN_IN_FB: "Inicia sesión con Facebook",
      SIGN_IN_TW: "Inicia sesión con Twitter",
      SIGN_IN_GG: "Inicia sesión con Google",
      SIGN_IN_EM: "Inicia sesión con tu correo electrónico",
      YOUR_EMAIL: "Tu correo electrónico",
      YOUR_PASSWORD: "Tu contraseña",
      REMEMBER: "Recuérdame",
      FORGOT: "¿Olvidar?",
      HAVE_ACCOUNT_YET: "¿Aún no tienes una cuenta de Time Out?",
      JOIN_HERE: "Únete aquí",
      ALMOST_THERE: "Ya casi está",

      FORGOT_HEADER: "¿Has olvidado tu contraseña?",
      FORGOT_SUBTITLE: "No hay problema. Introduce tu dirección de correo electrónico abajo y te enviaremos un enlace para restaurarla",
      SEND_LINK: "Envía el enlace",

      RECEIVE_EMAIL: "Gracias, recibirás pronto un correo electrónico",
      MANAGE_ACCOUNT: "Administra tu cuenta",
      EDIT_DETAILS_HERE: "Puedes editar los detalles de tu cuenta aquí",
      FIRST_NAME: "Nombre",
      LAST_NAME: "Apellido",
      SCREEN_NAME: "Nombre de perfil",
      EMAIL: "Correo electrónico",
      ACCOUNT_DETAILS: "Detalles de la cuenta",
      PASSWORD: "Contraseña",
      SAVE_CHANGES: "Guardar cambios",
      UPLOAD_PIC: "Sube una nueva foto de perfil",
      CHOOSE_PHOTO: "Escoge una foto de tu dispositivo de máximo 2MB.",
      CLOSE_ACCOUNT: "Cerrar mi cuenta",
      PASSWORD_BELOW: "Puedes cambiar tu contraseña abajo",
      CURRENT_PASSWORD: "Contraseña actual",
      NEW_PASSWORD: "Nueva contraseña",
      REPEAT_PASSWORD: "Repite la nueva contraseña",

      OOPS: "Ups,",
      ERROR_404_OCCURED: "Ocurrió un error…",
      ERROR_404_INFO: "Se ha movido la página o ya no existe.",
      ERROR_500_TITLE: "El servidor ha vuelto a",
      SMTH_BROKEN: "Algo no funciona.",
      INTERNAL_RED: "500 Internal Server Error",
      LET_KNOW_RED: "Por favor, dinos qué estabas haciendo cuando ocurrió este error. Lo arreglaremos tan pronto como sea posible. Lamentamos cualquier inconveniente causado.",
      ERROR_500_INFO: "what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.",

      EMAIL_ERROR: "Por favor, introduce una dirección válida de correo electrónico",
      FIRST_NAME_ERROR: "Por favor, introduce tu nombre",
      LAST_NAME_ERROR: "Por favor, introduce tu apellido",
      TERM_OF_USE_ERROR: "Debe aceptar nuestros términos de uso",
      SIGN_IN_VALIDATION_ERROR: "Correo electrónico o contraseña incorrectos. Por favor, inténtalo de nuevo",
      ACCOUNT_PASSWORDS_VALIDATION: "No coincide la contraseña",
      WAS_IT: "¿Ha sido algo que hemos hecho?",
      DELETE_ACCOUNT_TEXT: "Lamentamos que quieras borrar tu cuenta. Si hay algo por lo que quieres salir, ",
      DELETE_ACCOUNT: "Borrar cuenta",
      CANCEL: "Cancelar",

      UPDATE_PASSWORD: "Actualice su contraseña",
      PASSWORD_UPDATE_SUCCESS: "Tu contraseña ha sido actualizada",
      ERROR_PASSWORD_LENGTH: "La contraseña debe contener al menos 6 caracteres",

      ERROR_MISSING_SITE_PARAMETER: "Falta el parámetro de aplicación requerido: site",
      ERROR_ALREADY_REGISTERED: "Ya te habías registrado previamente usando tu email. Por favor, usa {{email}} para acceder en tu cuenta",
    },
    'es-barcelona': { TERM_OF_USE: terms, },
    'es-madrid': { TERM_OF_USE: terms, },
    'es-girona': { TERM_OF_USE: terms, },
  }
}



// WEBPACK FOOTER //
// ./translations/es-419.js